import {
  useDeleteGroup,
  useGroup,
  useOptionValues,
  useUpsertGroup,
} from '@/hooks';
import { Box } from '@mui/material';
import { useNavigate, useParams, useSearchParams } from 'react-router';
import { GroupForm } from './GroupForm';

const DEFAULT_GROUP = {
  name: '',
};

export function Group() {
  const { code } = useParams();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const {
    query: { data: fetchedGroup },
  } = useGroup(code, searchParams.has('copy'));
  const group = code === 'new' ? DEFAULT_GROUP : fetchedGroup;
  const typeOptions = useOptionValues('groupType');
  const { mutate: upsertGroup } = useUpsertGroup();
  const { mutate: deleteGroup } = useDeleteGroup();

  function handleDelete() {
    deleteGroup(code, {
      onSuccess: () => {
        navigate('..', { replace: true });
      },
    });
  }

  function handleSubmit(values) {
    upsertGroup(values, {
      onSuccess: (data) => {
        navigate(`../${data.code}`, { replace: true });
      },
    });
  }

  return (
    <Box sx={{ flexGrow: 1, p: 1 }}>
      <title>
        {['IR3', 'Groups & Areas', group?._id ? group.name : 'New Group'].join(
          ' | ',
        )}
      </title>
      <GroupForm
        key={[group?._id, group?.lastEdit?.time]}
        defaultValues={group}
        onSubmit={handleSubmit}
        onDelete={handleDelete}
        typeOptions={typeOptions}
      />
    </Box>
  );
}
